// import React, { useState, useEffect } from "react";

// export default function Header() {
//   const [showTopBar, setShowTopBar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [openMenu, setOpenMenu] = useState("");

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }
//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   const menuItems = {
//     ABOUT: ["About School", "Director Message", "Vision & Mission"],
//     PROGRAMS: ["Primary", "Middle", "Senior"],
//     ADMISSIONS: ["Admission Process", "Fees", "Enquiry Form"],
//     "OUR SCHOOLS": ["Ladwa", "Kurukshetra", "Pehowa"],
//   };

//   const navItemStyle = {
//     color: "#222",
//     textDecoration: "none",
//     cursor: "pointer",
//     position: "relative",
//     padding: "10px 0",
//     display: "inline-block",
//   };

//   return (
//     <>
//       <div
//          style={{
//     position: "fixed",
//     top: showTopBar ? 0 : "-50px",
//     left: 0,
//     width: "100%",
//     height: "50px",
//     background: "rgb(0, 111, 47)",
//     color: "white",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1100,
//     transition: "top 0.3s ease",
//     boxSizing: "border-box",
//     overflow: "hidden",
//   }}
//       >
//         <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//           <div style={{ flex: 1, textAlign: "center", fontSize: "18px" }}>
//             Admissions Open For Yello 2026-2027. Limited Seats!
//           </div>
//           <div
//             style={{
//               background: "rgb(0, 111, 47)",
//               color: "white",
//               height: "50px",
//               padding: "0 25px",
//               display: "flex",
//               alignItems: "center",
//               fontWeight: "600",
//               clipPath: "polygon(8% 0, 100% 0, 92% 100%, 0 100%)",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Contact Us: +91 87489 95555
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//     position: "sticky",
//     top: "0px",
//     zIndex: 1000,
//     marginTop: "50px",
//     background: "#f6f7fb",
//     boxShadow: "0 1px 8px rgba(0,0,0,0.08)",
//   }}
//       >
//         <div
//           style={{
//             height: "90px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             padding: "0 25px",
//             boxSizing: "border-box",
//             position: "relative",
//           }}
//         >
//           <div style={{ fontSize: "20px", fontWeight: "700", lineHeight: 1 }}>
//             <span style={{ color: "rgb(0, 111, 47)" }}>Delhi</span>
//             <span style={{ color: "rgb(0, 111, 47)" }}> Public</span>
//             <span style={{ color: "rgb(0, 111, 47)" }}> School</span>
//             <span style={{ color: "rgb(0, 111, 47)" }}> Ladwa</span>
//           </div>

//           <div style={{ display: "flex", alignItems: "center", gap: "28px", fontSize: "16px", fontWeight: "600" }}>
//             <a style={{ color: "rgb(0, 111, 47)", textDecoration: "none" }} href="#">
//               HOME
//             </a>

//             {Object.keys(menuItems).map((item) => (
//               <div
//                 key={item}
//                 style={{ position: "relative" }}
//                 onMouseEnter={() => setOpenMenu(item)}
//                 onMouseLeave={() => setOpenMenu("")}
//               >
//                 <a style={navItemStyle} href="#">
//                   {item} ▼
//                 </a>

//                 {openMenu === item && (
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: "42px",
//                       left: 0,
//                       minWidth: "220px",
//                       background: "#fff",
//                       boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
//                       borderRadius: "8px",
//                       overflow: "hidden",
//                       zIndex: 2000,
//                     }}
//                   >
//                     {menuItems[item].map((sub, idx) => (
//   <a
//     key={idx}
//     href="#"
//     style={{
//       display: "block",
//       padding: "12px 16px",
//       color: "#222",
//       textDecoration: "none",
//       borderBottom: idx !== menuItems[item].length - 1 ? "1px solid #eee" : "none",
//       background: "#fff",
//       transition: "0.3s",
//     }}
//     onMouseEnter={(e) => {
//       e.currentTarget.style.background = "rgb(0, 111, 47)";
//       e.currentTarget.style.color = "#fff";
//     }}
//     onMouseLeave={(e) => {
//       e.currentTarget.style.background = "#fff";
//       e.currentTarget.style.color = "#222";
//     }}
//   >
//     {sub}
//   </a>
// ))}
//                   </div>
//                 )}
//               </div>
//             ))}

//             <a style={{ color: "#222", textDecoration: "none" }} href="#">
//               YELLO LIFE
//             </a>
//             <a style={{ color: "#222", textDecoration: "none" }} href="#">
//               CONTACT US
//             </a>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";

// export default function Header() {
//   const [showTopBar, setShowTopBar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [openMenu, setOpenMenu] = useState("");

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }
//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   const menuItems = {
//     ABOUT: ["About School", "Director Message", "Vision & Mission"],
//     PROGRAMS: ["Primary", "Middle", "Senior"],
//     ADMISSIONS: ["Admission Process", "Fees", "Enquiry Form"],
//     "OUR SCHOOLS": ["Ladwa", "Kurukshetra", "Pehowa"],
//   };

//   const navItemStyle = {
//     color: "#222",
//     textDecoration: "none",
//     cursor: "pointer",
//     position: "relative",
//     padding: "10px 0",
//     display: "inline-block",
//   };

//   return (
//     <>
    
//     <div
//   style={{
//     position: "fixed",
//     top: showTopBar ? 0 : "-50px",
//     left: 0,
//     width: "100%",
//     height: "50px",
//     background: "rgb(0, 111, 47)",
//     color: "white",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1100,
//     transition: "top 0.3s ease",
//     boxSizing: "border-box",
//     overflow: "hidden",
//   }}
// >
//   <div
//     style={{
//       width: "100%",
//       maxWidth: "1400px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       padding: "0 20px",
//       boxSizing: "border-box",
//     }}
//   >
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         gap: "18px",
//         color: "#fff",
//         fontSize: "15px",
//         fontWeight: "500",
//         whiteSpace: "nowrap",
//       }}
//     >
//       <span>📞 +91 87489 95555</span>
//       <span>✉️ info@dpskidsladwa.com</span>
//     </div>

//     <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//       <a
//         href="#"
//         style={{
//           color: "#fff",
//           textDecoration: "none",
//           width: "34px",
//           height: "34px",
//           borderRadius: "50%",
//           border: "1px solid rgba(255,255,255,0.45)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: "16px",
//           transition: "0.3s",
//         }}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.background = "#fff";
//           e.currentTarget.style.color = "rgb(0, 111, 47)";
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.background = "transparent";
//           e.currentTarget.style.color = "#fff";
//         }}
//       >
//         f
//       </a>

//       <a
//         href="#"
//         style={{
//           color: "#fff",
//           textDecoration: "none",
//           width: "34px",
//           height: "34px",
//           borderRadius: "50%",
//           border: "1px solid rgba(255,255,255,0.45)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: "16px",
//           transition: "0.3s",
//         }}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.background = "#fff";
//           e.currentTarget.style.color = "rgb(0, 111, 47)";
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.background = "transparent";
//           e.currentTarget.style.color = "#fff";
//         }}
//       >
//         ⌾
//       </a>
//     </div>
//   </div>
// </div>

//       <div
//         style={{
//           position: "fixed",
//           top: showTopBar ? "50px" : "0px",
//           left: 0,
//           width: "100%",
//           zIndex: 1000,
//           background: "#f6f7fb",
//           boxShadow: "0 1px 8px rgba(0,0,0,0.08)",
//           transition: "top 0.3s ease",
//         }}
//       >
//         <div
//           style={{
//             height: "90px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             padding: "0 25px",
//             boxSizing: "border-box",
//             position: "relative",
//           }}
//         >
//           <div style={{ fontSize: "20px", fontWeight: "700", lineHeight: 1 }}>
//             <span style={{ color: "rgb(0, 111, 47)" }}>Delhi</span>
//             <span style={{ color: "rgb(0, 111, 47)" }}> Public</span>
//             <span style={{ color: "rgb(0, 111, 47)" }}> School</span>
//             <span style={{ color: "rgb(0, 111, 47)" }}> Ladwa</span>
//           </div>

//           <div style={{ display: "flex", alignItems: "center", gap: "28px", fontSize: "16px", fontWeight: "600" }}>
//             <a style={{ color: "rgb(0, 111, 47)", textDecoration: "none" }} href="#">
//               HOME
//             </a>

//             {Object.keys(menuItems).map((item) => (
//               <div
//                 key={item}
//                 style={{ position: "relative" }}
//                 onMouseEnter={() => setOpenMenu(item)}
//                 onMouseLeave={() => setOpenMenu("")}
//               >
//                 <a style={navItemStyle} href="#">
//                   {item} ▼
//                 </a>

//                 {openMenu === item && (
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: "42px",
//                       left: 0,
//                       minWidth: "220px",
//                       background: "#fff",
//                       boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
//                       borderRadius: "8px",
//                       overflow: "hidden",
//                       zIndex: 2000,
//                     }}
//                   >
//                     {menuItems[item].map((sub, idx) => (
//                       <a
//                         key={idx}
//                         href="#"
//                         style={{
//                           display: "block",
//                           padding: "12px 16px",
//                           color: "#222",
//                           textDecoration: "none",
//                           borderBottom: idx !== menuItems[item].length - 1 ? "1px solid #eee" : "none",
//                           background: "#fff",
//                           transition: "0.3s",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.background = "rgb(0, 111, 47)";
//                           e.currentTarget.style.color = "#fff";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.background = "#fff";
//                           e.currentTarget.style.color = "#222";
//                         }}
//                       >
//                         {sub}
//                       </a>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             ))}

//             <a style={{ color: "#222", textDecoration: "none" }} href="#">
//               YELLO LIFE
//             </a>
//             <a style={{ color: "#222", textDecoration: "none" }} href="#">
//               CONTACT US
//             </a>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";

// export default function Header() {
//   const [showTopBar, setShowTopBar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [openMenu, setOpenMenu] = useState("");

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;

//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }

//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   const navStyle = {
//     cursor: "pointer",
//     fontWeight: "600",
//     color: "#222",
//   };

//   return (
//     <>
//       {/* 🔝 TOP BAR */}
//       <div
//         style={{
//           position: "fixed",
//           top: showTopBar ? 0 : "-50px",
//           width: "100%",
//           height: "50px",
//           background: "rgb(0,111,47)",
//           color: "#fff",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           padding: "0 20px",
//           zIndex: 1100,
//           transition: "0.3s",
//         }}
//       >
//         <div>📞 +91 90534 90023 | ✉️ dpskidsladwa@gmail.com</div>
//       </div>

//       {/* 🔻 MAIN HEADER */}
//       <div
//         style={{
//           position: "fixed",
//           top: showTopBar ? "50px" : "0px",
//           width: "100%",
//           background: "#fff",
//           boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//           zIndex: 1000,
//         }}
//       >
//         <div
//           style={{
//             height: "90px",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "0 30px",
//           }}
//         >
//           {/* LOGO */}
//           <div style={{ fontWeight: "700", fontSize: "20px", color: "rgb(0,111,47)" }}>
//             DPS Kids Ladwa
//           </div>

//           {/* MENU */}
//           <div style={{ display: "flex", gap: "30px" }}>
//             <span style={{ ...navStyle, color: "rgb(0,111,47)" }}>
//               HOME
//             </span>

//             {/* ABOUT US */}
//             <div
//               onMouseEnter={() => setOpenMenu("about")}
//               onMouseLeave={() => setOpenMenu("")}
//               style={{ position: "relative" }}
//             >
//               <span style={navStyle}>ABOUT US ▼</span>

//               {openMenu === "about" && (
//                 <div className="dropdown">
//                   <div className="dropdown-item">Our School</div>
//                 </div>
//               )}
//             </div>

//             {/* MISSION & VISION */}
//             <div
//               onMouseEnter={() => setOpenMenu("mission")}
//               onMouseLeave={() => setOpenMenu("")}
//               style={{ position: "relative" }}
//             >
//               <span style={navStyle}>MISSION & VISION ▼</span>

//               {openMenu === "mission" && (
//                 <div className="dropdown">
//                   <div className="dropdown-item">Our Mission</div>
//                   <div className="dropdown-item">Our Vision</div>
//                 </div>
//               )}
//             </div>

//             {/* SIMPLE LINKS */}
//             <span style={navStyle}>AIMS & OBJECTIVES</span>
//             <span style={navStyle}>FACILITIES</span>
//             <span style={navStyle}>SPORTS</span>
//             <span style={navStyle}>ACTIVITIES</span>
//             <span style={navStyle}>CONTACT</span>
//           </div>
//         </div>
//       </div>

//       {/* 🔥 CSS INLINE FIX */}
//       <style>
//         {`
//           .dropdown {
//             position: absolute;
//             top: 40px;
//             left: 0;
//             background: #fff;
//             box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//             border-radius: 8px;
//             overflow: hidden;
//             min-width: 200px;
//           }

//           .dropdown-item {
//             padding: 12px 16px;
//             cursor: pointer;
//             transition: 0.3s;
//           }

//           .dropdown-item:hover {
//             background: rgb(0,111,47);
//             color: #fff;
//           }
//         `}
//       </style>
//     </>
//   );
// }

// import React, { useState, useEffect, useRef } from "react";
// import { Navigate } from "react-router-dom";
// import { useNavigate } from 'react-router-dom';
// export default function Header() {
//   const [showTopBar, setShowTopBar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [openMenu, setOpenMenu] = useState("");
//   const timeoutRef = useRef(null);
// const navigate = useNavigate();

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;

//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }

//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   const navStyle = {
//     cursor: "pointer",
//     fontWeight: "600",
//     color: "#222",
//   };

//   // ✅ HOVER CONTROL (FIX)
//   const handleEnter = (menu) => {
//     clearTimeout(timeoutRef.current);
//     setOpenMenu(menu);
//   };

//   const handleLeave = () => {
//     timeoutRef.current = setTimeout(() => {
//       setOpenMenu("");
//     }, 200); // 👈 delay = no flicker
//   };

//   return (
//     <>
//       {/* 🔝 TOP BAR */}
//       <div
//         style={{
//           position: "fixed",
//           top: showTopBar ? 0 : "-50px",
//           width: "100%",
//           height: "50px",
//           background: "rgb(0,111,47)",
//           color: "#fff",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           padding: "0 20px",
//           zIndex: 1100,
//           transition: "0.3s",
//         }}
//       >
//         <div>📞 +91 90534 90023 | ✉️ dpskidsladwa@gmail.com</div>
//       </div>

//       {/* 🔻 MAIN HEADER */}
//       <div
//         style={{
//           position: "fixed",
//           top: showTopBar ? "50px" : "0px",
//           width: "100%",
//           background: "#fff",
//           boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//           zIndex: 1000,
//         }}
//       >
//         <div
//           style={{
//             height: "90px",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "0 30px",
//           }}
//         >
//           {/* LOGO */}
//           <div style={{ fontWeight: "700", fontSize: "20px", color: "rgb(0,111,47)" }}>
//             DPS Kids Ladwa
//           </div>

//           {/* MENU */}
//           <div style={{ display: "flex", gap: "30px" }}>
//             <span style={{ ...navStyle, color: "rgb(0,111,47)" }}>
//               HOME
//             </span>

//             {/* ABOUT US */}
//             <div
//               onMouseEnter={() => handleEnter("about")}
//               onMouseLeave={handleLeave}
//               style={{ position: "relative" }}
//             >
//               <span style={navStyle}>ABOUT US ▼</span>

//               <div
//                 className="dropdown"
//                 style={{
//                   opacity: openMenu === "about" ? 1 : 0,
//                   visibility: openMenu === "about" ? "visible" : "hidden",
//                   transform:
//                     openMenu === "about"
//                       ? "translateY(0px)"
//                       : "translateY(10px)",
//                   pointerEvents: openMenu === "about" ? "auto" : "none",
//                   transition: "all 0.25s ease",
//                 }}
//               >
//                 <div className="dropdown-item">Our School</div>
//               </div>
//             </div>

//             {/* MISSION & VISION */}
//             <div
//               onMouseEnter={() => handleEnter("mission")}
//               onMouseLeave={handleLeave}
//               style={{ position: "relative" }}
//             >
//               <span style={navStyle}>MISSION & VISION ▼</span>

//               <div
//                 className="dropdown"
//                 style={{
//                   opacity: openMenu === "mission" ? 1 : 0,
//                   visibility: openMenu === "mission" ? "visible" : "hidden",
//                   transform:
//                     openMenu === "mission"
//                       ? "translateY(0px)"
//                       : "translateY(10px)",
//                   pointerEvents: openMenu === "mission" ? "auto" : "none",
//                   transition: "all 0.25s ease",
//                 }}
//               >
//                  <div 
//   className="dropdown-item"  
//   onMouseDown={() => navigate('/urscreen')}
// >
//   Our School
// </div>
//                 <div className="dropdown-item">Our Vision</div>
//               </div>
//             </div>

//             {/* SIMPLE LINKS */}
//             <span style={navStyle}>AIMS & OBJECTIVES</span>
//             <span style={navStyle}>FACILITIES</span>
//             <span style={navStyle}>SPORTS</span>
//             <span style={navStyle}>ACTIVITIES</span>
//             <span style={navStyle}>CONTACT</span>
//           </div>
//         </div>
//       </div>

//       {/* 🔥 CSS */}
//       <style>
//         {`
//           .dropdown {
//             position: absolute;
//             top: 40px;
//             left: 0;
//             background: #fff;
//             box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//             border-radius: 8px;
//             overflow: hidden;
//             min-width: 200px;
//             z-index: 999;
//           }

//           .dropdown-item {
//             padding: 12px 16px;
//             cursor: pointer;
//             transition: 0.3s;
//           }

//           .dropdown-item:hover {
//             background: rgb(0,111,47);
//             color: #fff;
//           }
//         `}
//       </style>
//     </>
//   );
// }

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from 'react-router-dom'; // ✅ Sirf useNavigate kaafi hai

// export default function Header() {
//   const [showTopBar, setShowTopBar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [openMenu, setOpenMenu] = useState("");
//   const timeoutRef = useRef(null);
//   const navigate = useNavigate(); // ✅ Hook initialized

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }
//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   const navStyle = {
//     cursor: "pointer",
//     fontWeight: "600",
//     color: "#222",
//   };

//   const handleEnter = (menu) => {
//     clearTimeout(timeoutRef.current);
//     setOpenMenu(menu);
//   };

//   const handleLeave = () => {
//     timeoutRef.current = setTimeout(() => {
//       setOpenMenu("");
//     }, 200);
//   };

//   return (
//     <>
//       {/* 🔝 TOP BAR */}
//       <div style={{
//         position: "fixed",
//         top: showTopBar ? 0 : "-50px",
//         width: "100%",
//         height: "50px",
//         background: "rgb(0,111,47)",
//         color: "#fff",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "0 20px",
//         zIndex: 1100,
//         transition: "0.3s",
//       }}>
//         <div>📞 +91 90534 90023 | ✉️ dpskidsladwa@gmail.com</div>
//       </div>

//       {/* 🔻 MAIN HEADER */}
//       <div style={{
//         position: "fixed",
//         top: showTopBar ? "50px" : "0px",
//         width: "100%",
//         background: "#fff",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//         zIndex: 1000,
//         transition: "top 0.3s",
//       }}>
//         <div style={{
//           height: "90px",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "0 30px",
//         }}>
//           {/* LOGO - Click to Home */}
//           <div 
//             onClick={() => navigate('/')} 
//             style={{ fontWeight: "700", fontSize: "20px", color: "rgb(0,111,47)", cursor: "pointer" }}
//           >
//             DPS Kids Ladwa
//           </div>

//           {/* MENU */}
//           <div style={{ display: "flex", gap: "30px" }}>
//             {/* HOME */}
//             <span 
//               onClick={() => navigate('/')} 
//               style={{ ...navStyle, color: "rgb(0,111,47)" }}
//             >
//               HOME
//             </span>

//             {/* ABOUT US */}
//             <div
//               onMouseEnter={() => handleEnter("about")}
//               onMouseLeave={handleLeave}
//               style={{ position: "relative" }}
//             >
//               <span style={navStyle}>ABOUT US ▼</span>
//               <div className="dropdown" style={{
//                 opacity: openMenu === "about" ? 1 : 0,
//                 visibility: openMenu === "about" ? "visible" : "hidden",
//                 transform: openMenu === "about" ? "translateY(0px)" : "translateY(10px)",
//                 transition: "all 0.25s ease",
//               }}>
//                 <div className="dropdown-item" onClick={() => navigate('/ourscreen')}>
//                   Our School
//                 </div>
//               </div>
//             </div>

//             {/* MISSION & VISION */}
//             <div
//               onMouseEnter={() => handleEnter("mission")}
//               onMouseLeave={handleLeave}
//               style={{ position: "relative" }}
//             >
//               <span style={navStyle}>MISSION & VISION ▼</span>
//               <div className="dropdown" style={{
//                 opacity: openMenu === "mission" ? 1 : 0,
//                 visibility: openMenu === "mission" ? "visible" : "hidden",
//                 transform: openMenu === "mission" ? "translateY(0px)" : "translateY(10px)",
//                 transition: "all 0.25s ease",
//               }}>
//                 <div className="dropdown-item" onClick={() => navigate('/MissionVision')}>
//                   Our School
//                 </div>
//                 <div className="dropdown-item" onClick={() => navigate('/MissionVision')}>
//                   Our Vision
//                 </div>
//               </div>
//             </div>

//             {/* SIMPLE LINKS */}
//             <span style={navStyle} onClick={() => navigate('/AimsObjectives')}>AIMS & OBJECTIVES</span>
//             <span style={navStyle} onClick={() => navigate('/facilities')}>FACILITIES</span>
//             <span style={navStyle} onClick={() => navigate('/SportsFitness')}>SPORTS FITNESS</span>
//              <span style={navStyle} onClick={() => navigate('/Activities')}>ACTIVITIES</span>
//              <span style={navStyle} onClick={() => navigate('/ContactUs')}>CONTACT</span>
//           </div>
//         </div>
//       </div>

//       <style>
//         {`
//           .dropdown {
//             position: absolute;
//             top: 40px;
//             left: 0;
//             background: #fff;
//             box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//             border-radius: 8px;
//             overflow: hidden;
//             min-width: 200px;
//             z-index: 999;
//           }
//           .dropdown-item {
//             padding: 12px 16px;
//             cursor: pointer;
//             transition: 0.3s;
//             color: #222;
//           }
//           .dropdown-item:hover {
//             background: rgb(0,111,47);
//             color: #fff !important;
//           }
//         `}
//       </style>
//     </>
//   );
// }


// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// export default function Header() {
//   const [showTopBar, setShowTopBar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [openMenu, setOpenMenu] = useState("");
//   const [mobileMenu, setMobileMenu] = useState(false); // ✅ NEW
//   const timeoutRef = useRef(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isCurrentPage = (path) => location.pathname === path;

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }
//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   const navStyle = {
//     cursor: "pointer",
//     fontWeight: "600",
//     padding: "12px 10px",
//   };

//   const handleEnter = (menu) => {
//     clearTimeout(timeoutRef.current);
//     setOpenMenu(menu);
//   };

//   const handleLeave = () => {
//     timeoutRef.current = setTimeout(() => {
//       setOpenMenu("");
//     }, 200);
//   };

//   return (
//     <>
//       {/* TOP BAR */}
//       <div style={{
//         position: "fixed",
//         top: showTopBar ? 0 : "-50px",
//         width: "100%",
//         height: "50px",
//         background: "rgb(0,111,47)",
//         color: "#fff",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "0 20px",
//         zIndex: 1100,
//         transition: "0.3s",
//         fontSize: "14px"
//       }}>
//         <div>📞 +91 90534 90023 | ✉️ dpskidsladwa@gmail.com</div>
//       </div>

//       {/* MAIN HEADER */}
//       <div style={{
//         position: "fixed",
//         top: showTopBar ? "50px" : "0px",
//         width: "100%",
//         background: "#fff",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//         zIndex: 1000,
//         transition: "top 0.3s",
//       }}>
//         <div style={{
//           height: "80px",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "0 20px",
//         }}>
//           {/* LOGO */}
//           <div
//             onClick={() => navigate("/")}
//             style={{ fontWeight: "700", fontSize: "20px", color: "rgb(0,111,47)", cursor: "pointer" }}
//           >
//             DPS Kids Ladwa
//           </div>

//           {/* DESKTOP MENU */}
//           <div className="desktopMenu">
//             <span style={navStyle} onClick={() => navigate("/")}>HOME</span>
//             <span style={navStyle} onClick={() => navigate("/ourscreen")}>ABOUT</span>
//             <span style={navStyle} onClick={() => navigate("/MissionVision")}>MISSION</span>
//             <span style={navStyle} onClick={() => navigate("/AimsObjectives")}>AIMS</span>
//             <span style={navStyle} onClick={() => navigate("/facilities")}>FACILITIES</span>
//             <span style={navStyle} onClick={() => navigate("/ContactUs")}>CONTACT</span>
//           </div>

//           {/* MOBILE MENU BUTTON */}
//           <div
//             className="menuIcon"
//             onClick={() => setMobileMenu(true)}
//           >
//             ☰
//           </div>
//         </div>
//       </div>

//       {/* MOBILE DRAWER */}
//       <div className={`mobileDrawer ${mobileMenu ? "open" : ""}`}>
//         <div className="closeBtn" onClick={() => setMobileMenu(false)}>✖</div>

//         <span onClick={() => navigate("/")}>HOME</span>
//         <span onClick={() => navigate("/ourscreen")}>ABOUT</span>
//         <span onClick={() => navigate("/MissionVision")}>MISSION</span>
//         <span onClick={() => navigate("/AimsObjectives")}>AIMS</span>
//         <span onClick={() => navigate("/facilities")}>FACILITIES</span>
//         <span onClick={() => navigate("/ContactUs")}>CONTACT</span>
//       </div>

//       {/* STYLES */}
//       <style>{`
//         .desktopMenu {
//           display: flex;
//           gap: 25px;
//         }

//         .menuIcon {
//           display: none;
//           font-size: 26px;
//           cursor: pointer;
//         }

//         .mobileDrawer {
//           position: fixed;
//           top: 0;
//           right: -100%;
//           width: 260px;
//           height: 100vh;
//           background: #fff;
//           box-shadow: -5px 0 20px rgba(0,0,0,0.1);
//           padding: 20px;
//           display: flex;
//           flex-direction: column;
//           gap: 20px;
//           transition: 0.3s;
//           z-index: 2000;
//         }

//         .mobileDrawer.open {
//           right: 0;
//         }

//         .mobileDrawer span {
//           font-size: 16px;
//           font-weight: 600;
//           cursor: pointer;
//         }

//         .closeBtn {
//           font-size: 22px;
//           cursor: pointer;
//           margin-bottom: 10px;
//         }

//         /* RESPONSIVE */
//         @media (max-width: 900px) {
//           .desktopMenu {
//             display: none;
//           }
//           .menuIcon {
//             display: block;
//           }
//         }
//       `}</style>
//     </>
//   );
// }


// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from 'react-router-dom';

// export default function Header() {
//   const [showTopBar, setShowTopBar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [openMenu, setOpenMenu] = useState("");
//   const timeoutRef = useRef(null);
//   const navigate = useNavigate();
//   const location = useLocation(); // ✅ Current page detect karne ke liye

//   // In states
// const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

// // Update handleEnter/Leave (Sirf desktop pe chalein)
 

// // Ek toggle function mobile ke liye
// const toggleMobileSubmenu = (menu) => {
//   setOpenMenu(openMenu === menu ? "" : menu);
// };
//   // ✅ Current page check karne ka function
//   const isCurrentPage = (path) => {
//     return location.pathname === path;
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }
//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   const navStyle = {
//     cursor: "pointer",
//   fontWeight: "600",
//   padding: "12px 12px",  // ✅ YE CHANGE
//   lineHeight: "1.4",     // ✅ ADD
//   display: "inline-block" ,// ✅ ADD
//   fontFamily:'sans-serif',color: "rgb(0,111,47)"
//   };

//   const handleEnter = (menu) => {
//     clearTimeout(timeoutRef.current);
//     if (window.innerWidth > 1024) setOpenMenu(menu);
//     setOpenMenu(menu);
//   };

//   const handleLeave = () => {
//     timeoutRef.current = setTimeout(() => {
//       setOpenMenu("");
//     }, 200);
//   };

//   return (
//     <>
//       {/* 🔝 TOP BAR */}
//       <div style={{
//         position: "fixed",
//         top: showTopBar ? 0 : "-50px",
//         width: "100%",
//         height: "50px",
//         background: "rgb(0,111,47)",
//         color: "#fff",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "0 20px",
//         zIndex: 1100,
//         transition: "0.3s",
//       }}>
//         <div>📞 +91 90534 90023 | ✉️ dpskidsladwa@gmail.com</div>
//       </div>

//       {/* 🔻 MAIN HEADER */}
//       <div style={{
//         position: "fixed",
//         top: showTopBar ? "50px" : "0px",
//         width: "100%",
//         background: "#fff",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//         zIndex: 1000,
//         transition: "top 0.3s",
//       }}>
//         <div style={{
//           height: "90px",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "0 30px",
//         }}>
//           {/* LOGO - Click to Home */}
//           <div 
//             onClick={() => navigate('/')} 
//             style={{ fontWeight: "700", fontSize: "20px",fontFamily:'sans-serif',color: "rgb(0,111,47)", cursor: "pointer" }}
//           >
//             DPS Kids Ladwa
//           </div>

//           {/* MENU */}
//           <div style={{ display: "flex", gap: "30px" }}>
//             {/* HOME */}
//             <span 
//               onClick={() => navigate('/')} 
//               style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/') ? "800" : "600"
//               }}
//             >
//               HOME
//             </span>

//             {/* ABOUT US */}
//             <div
//               onMouseEnter={() => handleEnter("about")}
//               onMouseLeave={handleLeave}
//               style={{ position: "relative" }}
//             >
//               <span style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/ourscreen') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/ourscreen') ? "800" : "600"
//               }}>ABOUT US ▼</span>
//               <div className="dropdown" style={{
//                 opacity: openMenu === "about" ? 1 : 0,
//                 visibility: openMenu === "about" ? "visible" : "hidden",
//                 transform: openMenu === "about" ? "translateY(0px)" : "translateY(10px)",
//                 transition: "all 0.25s ease",
//               }}>
//                 <div className="dropdown-item" onClick={() => navigate('/ourscreen')}>
//                   Our School
//                 </div>
//                 <div className="dropdown-item" onClick={() => navigate('/ourscreen')}>
//                  School staff
//                 </div>
//                 <div className="dropdown-item" onClick={() => navigate('/ourscreen')}>
//                   Principle Message
//                 </div>
//                 <div className="dropdown-item" onClick={() => navigate('/ourscreen')}>
//                   School Transport
//                 </div>
               
//               </div>
//             </div>

//             {/* MISSION & VISION */}
//             <div
//               onMouseEnter={() => handleEnter("mission")}
//               onMouseLeave={handleLeave}
//               style={{ position: "relative" }}
//             >
//               <span style={{ 
//                 ...navStyle, 
//                 color: (isCurrentPage('/MissionVision')) ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/MissionVision') ? "800" : "600"
//               }}>MISSION & VISION ▼</span>
//               <div className="dropdown" style={{
//                 opacity: openMenu === "mission" ? 1 : 0,
//                 visibility: openMenu === "mission" ? "visible" : "hidden",
//                 transform: openMenu === "mission" ? "translateY(0px)" : "translateY(10px)",
//                 transition: "all 0.25s ease",
//               }}>
//                 <div className="dropdown-item" onClick={() => navigate('/MissionVision')}>
//                   Our Mission
//                 </div>
//                 <div className="dropdown-item" onClick={() => navigate('/MissionVision')}>
//                   Our Vision
//                 </div>
//               </div>
//             </div>

//             {/* SIMPLE LINKS */}
//             <span 
//               style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/AimsObjectives') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/AimsObjectives') ? "800" : "600"
//               }} 
//               onClick={() => navigate('/AimsObjectives')}
//             >
//               AIMS & OBJECTIVES
//             </span>
            
//             <span 
//               style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/facilities') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/facilities') ? "800" : "600"
//               }} 
//               onClick={() => navigate('/facilities')}
//             >
//               FACILITIES
//             </span>
            
//             <span 
//               style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/SportsFitness') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/SportsFitness') ? "800" : "600"
//               }} 
//               onClick={() => navigate('/SportsFitness')}
//             >
//               SPORTS FITNESS
//             </span>
            
//             <span 
//               style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/Activities') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/Activities') ? "800" : "600"
//               }} 
//               onClick={() => navigate('/Activities')}
//             >
//               ACTIVITIES
//             </span>
            
//             <span 
//               style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/ContactUs') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/ContactUs') ? "800" : "600"
//               }} 
//               onClick={() => navigate('/ContactUs')}
//             >
//               CONTACT
//             </span>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         .dropdown {
//           position: absolute;
//           top: 40px;
//           left: 0;
//           background: #fff;
//           box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//           border-radius: 8px;
//           overflow: hidden;
//           min-width: 200px;
//           z-index: 999;
//         }
//         .dropdown-item {
//           padding: 12px 16px;
//           cursor: pointer;
//           transition: 0.3s;
//           color: #222;
//         }
//         .dropdown-item:hover {
//           background: rgb(0,111,47);
//           color: #fff !important;
//         }
//       `}</style>
//     </>
//   );
// }

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from 'react-router-dom';

// export default function Header() {
//   const [showTopBar, setShowTopBar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [openMenu, setOpenMenu] = useState("");
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // ✅ Mobile Toggle State
//   const timeoutRef = useRef(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isCurrentPage = (path) => location.pathname === path;

//   const toggleMobileSubmenu = (menu) => {
//     setOpenMenu(openMenu === menu ? "" : menu);
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }
//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   const navStyle = {
//     cursor: "pointer",
//     fontWeight: "600",
//     padding: "12px 12px",
//     lineHeight: "1.4",
//     display: "inline-block",
//     fontFamily: 'sans-serif',
//     color: "rgb(0,111,47)"
//   };

//   const handleEnter = (menu) => {
//     if (window.innerWidth > 1024) {
//       clearTimeout(timeoutRef.current);
//       setOpenMenu(menu);
//     }
//   };

//   const handleLeave = () => {
//     if (window.innerWidth > 1024) {
//       timeoutRef.current = setTimeout(() => {
//         setOpenMenu("");
//       }, 200);
//     }
//   };

//   // Click handler to close menu on mobile after selection
//   const handleNavClick = (path) => {
//     navigate(path);
//     setIsMobileMenuOpen(false);
//     setOpenMenu("");
//   };

//   return (
//     <>
//       {/* 🔝 TOP BAR */}
//       <div style={{
//         position: "fixed",
//         top: showTopBar ? 0 : "-50px",
//         width: "100%",
//         height: "50px",
//         background: "rgb(0,111,47)",
//         color: "#fff",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "0 20px",
//         zIndex: 1100,
//         transition: "0.3s",
//       }}>
//         <div className="top-info">📞 +91 90534 90023 <span className="hide-mobile">| ✉️ dpskidsladwa@gmail.com</span></div>
//       </div>

//       {/* 🔻 MAIN HEADER */}
//       <div style={{
//         position: "fixed",
//         top: showTopBar ? "50px" : "0px",
//         width: "100%",
//         background: "#fff",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//         zIndex: 1000,
//         transition: "top 0.3s",
//       }}>
//         <div style={{
//           height: "90px",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "0 30px",
//         }}>
//           {/* LOGO */}
//           <div 
//             onClick={() => handleNavClick('/')} 
//             style={{ fontWeight: "700", fontSize: "20px", fontFamily: 'sans-serif', color: "rgb(0,111,47)", cursor: "pointer" }}
//           >
//             DPS Kids Ladwa
//           </div>

//           {/* 📱 HAMBURGER ICON (Sirf mobile pe dikhega) */}
//           <div className="hamburger" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
//             <div className={`line ${isMobileMenuOpen ? "active" : ""}`}></div>
//             <div className={`line ${isMobileMenuOpen ? "active" : ""}`}></div>
//             <div className={`line ${isMobileMenuOpen ? "active" : ""}`}></div>
//           </div>

//           {/* MENU - desktop class added */}
//           <div className={`nav-links ${isMobileMenuOpen ? "open" : ""}`}>
//             <span 
//               onClick={() => handleNavClick('/')} 
//               style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/') ? "800" : "600"
//               }}
//             >
//               HOME
//             </span>

//             <div
//               onMouseEnter={() => handleEnter("about")}
//               onMouseLeave={handleLeave}
//               className="nav-item-container"
//             >
//               <span onClick={() => toggleMobileSubmenu("about")} style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/ourscreen') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/ourscreen') ? "800" : "600"
//               }}>ABOUT US ▼</span>
//               <div className={`dropdown ${openMenu === "about" ? "show" : ""}`}>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/ourscreen')}>Our School</div>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/ourscreen')}>School staff</div>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/ourscreen')}>Principle Message</div>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/ourscreen')}>School Transport</div>
//               </div>
//             </div>

//             <div
//               onMouseEnter={() => handleEnter("mission")}
//               onMouseLeave={handleLeave}
//               className="nav-item-container"
//             >
//               <span onClick={() => toggleMobileSubmenu("mission")} style={{ 
//                 ...navStyle, 
//                 color: (isCurrentPage('/MissionVision')) ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/MissionVision') ? "800" : "600"
//               }}>MISSION & VISION ▼</span>
//               <div className={`dropdown ${openMenu === "mission" ? "show" : ""}`}>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/MissionVision')}>Our Mission</div>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/MissionVision')}>Our Vision</div>
//               </div>
//             </div>

//             <span style={navStyle} onClick={() => handleNavClick('/AimsObjectives')}>AIMS & OBJECTIVES</span>
//             <span style={navStyle} onClick={() => handleNavClick('/facilities')}>FACILITIES</span>
//             <span style={navStyle} onClick={() => handleNavClick('/SportsFitness')}>SPORTS FITNESS</span>
//             <span style={navStyle} onClick={() => handleNavClick('/Activities')}>ACTIVITIES</span>
//             <span style={navStyle} onClick={() => handleNavClick('/ContactUs')}>CONTACT</span>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         /* DESKTOP STYLES (SAME AS YOURS) */
//         .nav-links { display: flex; gap: 30px; }
//         .nav-item-container { position: relative; }
        
//         .dropdown {
//           position: absolute; top: 40px; left: 0; background: #fff;
//           box-shadow: 0 10px 25px rgba(0,0,0,0.1); border-radius: 8px;
//           overflow: hidden; min-width: 200px; z-index: 999;
//           opacity: 0; visibility: hidden; transform: translateY(10px);
//           transition: all 0.25s ease;
//         }
        // .dropdown.show { opacity: 1; visibility: visible; transform: translateY(0px); }
        // .dropdown-item { padding: 12px 16px; cursor: pointer; transition: 0.3s; color: #222; }
        // .dropdown-item:hover { background: rgb(0,111,47); color: #fff !important; }

        // .hamburger { display: none; cursor: pointer; flex-direction: column; gap: 5px; }
        // .line { width: 25px; height: 3px; background: rgb(0,111,47); transition: 0.3s; }

//         /* 📱 MOBILE ONLY CHANGES */
//         @media (max-width: 1024px) {
//           .hide-mobile { display: none; }
//           .hamburger { display: flex; z-index: 1001; }
          
//           .nav-links {
//             position: fixed; top: 0; right: -100%; width: 280px; height: 100vh;
//             background: #fff; flex-direction: column; padding: 100px 20px 20px;
//             transition: 0.4s ease; box-shadow: -5px 0 15px rgba(0,0,0,0.1);
//             gap: 10px; overflow-y: auto;
//           }
//           .nav-links.open { right: 0; }

//           .dropdown {
//             position: static; opacity: 1; visibility: visible; 
//             box-shadow: none; display: none; transform: none;
//             padding-left: 20px; border-left: 2px solid rgb(0,111,47);
//           }
//           .dropdown.show { display: block; }

//           /* Hamburger to X animation */
//           .line.active:nth-child(1) { transform: translateY(8px) rotate(45deg); }
//           .line.active:nth-child(2) { opacity: 0; }
//           .line.active:nth-child(3) { transform: translateY(-8px) rotate(-45deg); }
//         }
//       `}</style>
//     </>
//   );
// }

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from 'react-router-dom';
//  import { DataContext } from "./DataContext";
//  import { FaFacebookF, FaInstagram } from "react-icons/fa";

 
//  import logo from "./dpslogo.png";
// export default function Header() {
//   const [showTopBar, setShowTopBar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [openMenu, setOpenMenu] = useState("");
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const timeoutRef = useRef(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // ✅ Active page detect karne ka function
//   const isCurrentPage = (path) => location.pathname === path;

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }
//       setLastScrollY(currentScrollY);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   // ✅ Base Style (Color removed from here to handle via Logic)
//   const navStyle = {
//     cursor: "pointer",
//     padding: "12px 12px",
//     lineHeight: "1.4",
//     display: "inline-block",
//     fontFamily: 'sans-serif',
//     transition: "0.3s",
   
//   };
// const [hovered, setHovered] = useState(null);

//   const iconStyle = (name) => ({
//     color: hovered === name ? "rgb(0,111,47)" : "#fff",
//     fontSize: "12px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     width: "28px",
//     height: "28px",
//     borderRadius: "50%",
//     background: hovered === name ? "#fff" : "rgba(255,255,255,0.2)",
//     textDecoration: "none",
//     transition: "all 0.3s ease",
//     cursor: "pointer",
//   });
//   const handleEnter = (menu) => {
//     if (window.innerWidth > 1024) {
//       clearTimeout(timeoutRef.current);
//       setOpenMenu(menu);
//     }
//   };

//   const handleLeave = () => {
//     if (window.innerWidth > 1024) {
//       timeoutRef.current = setTimeout(() => setOpenMenu(""), 200);
//     }
//   };

//   const toggleMobileSubmenu = (menu) => {
//     setOpenMenu(openMenu === menu ? "" : menu);
//   };

//   const handleNavClick = (path) => {
//     navigate(path);
//     setIsMobileMenuOpen(false);
//     setOpenMenu("");
//   };

//   return (
//     <>
//       {/* 🔝 TOP BAR */}
//       {/* <div style={{
//         position: "fixed",
//         top: showTopBar ? 0 : "-50px",
//         width: "100%",
//         height: "50px",
//         background: "rgb(0,111,47)",
//         color: "#fff",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "0 20px",
//         zIndex: 1100,
//         transition: "0.3s",
//       }}>
//         <div style={{ fontSize: "14px" }}>
//           📞 +91 90534 90023 <span className="hide-mobile">| ✉️ dpskidsladwa@gmail.com</span>
//         </div>
//       </div> */}

//   <div style={{
//   position: "fixed",
//   top: showTopBar ? 0 : "-50px",
//   width: "100%",
//   height: "50px",
//   background: "rgb(0,111,47)",
//   color: "#fff",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",  // ✅ Ye already perfect hai
//   padding: "0 20px 0 20px",        // 🔥 LEFT/RIGHT same padding
//   boxSizing: "border-box",         // 🔥 MOST IMPORTANT!
//   zIndex: 1100,
//   transition: "0.3s",
// }}>
//   {/* LEFT SIDE */}
//  {/* LEFT SIDE - 📞 PURE WHITE */}
// <div style={{ 
//   fontSize: "14px", 
//   flexShrink: 0,
//   color: "#ffffff",  // 🔥 Pure White Text
//   display: "flex",
//   alignItems: "center",
//   gap: "5px"
// }}>
//   {/* Emoji ko thoda opacity ya filter dekar white look de sakte hain agar browser support kare */}
//   <span style={{ 
//     filter: "brightness(0) invert(1)", // 🔥 Ye trick emoji ko white/grayscale kar degi
//     fontSize: "16px" 
//   }}>
//     📞
//   </span> 
  
//   <span style={{ color: "#ffffff" }}>+91 90534 90023</span>
  
//   <span className="hide-mobile" style={{ marginLeft: "10px", color: "#ffffff" }}>
//     | ✉️ dpskidsladwa@gmail.com
//   </span>
// </div>
 
//   {/* RIGHT SIDE ICONS - 🔥 ULTRA RESPONSIVE */}
//   <div style={{ 
//     display: "flex", 
//     gap: "8px", 
//     flexShrink: 0,           // 🔥 Icons kabhi shrink nahi honge
//     paddingLeft: "10px"      // 🔥 Internal left space
//   }}>
//     <a href="https://www.facebook.com/dpskidsladwa" target="_blank" rel="noopener noreferrer"
//        style={iconStyle("fb")} onMouseEnter={() => setHovered("fb")} onMouseLeave={() => setHovered(null)}>
//       <FaFacebookF />
//     </a>

//     <a href="https://www.instagram.com/dpskids_ladwa" target="_blank" rel="noopener noreferrer"
//        style={iconStyle("ig")} onMouseEnter={() => setHovered("ig")} onMouseLeave={() => setHovered(null)}>
//       <FaInstagram />
//     </a>
//   </div>
 
//   {/* <div style={{ display: "flex", gap: "12px", marginRight:50 }}>
//     <a
//       href="https://www.facebook.com/dpskidsladwa"
//       target="_blank"
//       rel="noopener noreferrer"
//       style={{
//         color: "#fff",
//         fontSize: "16px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         width: "30px",
//         height: "30px",
//         borderRadius: "50%",
//         background: "rgba(255,255,255,0.2)",
//         textDecoration: "none",
//         transition: "0.3s",
//       }}
//       onMouseEnter={(e) => (e.target.style.background = "#fff", e.target.style.color = "rgb(0,111,47)")}
//       onMouseLeave={(e) => (e.target.style.background = "rgba(255,255,255,0.2)", e.target.style.color = "#fff")}
//     >
//       <FaFacebookF />
//     </a>

//     <a
//       href="https://www.instagram.com/dpskids_ladwa"
//       target="_blank"
//       rel="noopener noreferrer"
//       style={{
//         color: "#fff",
//         fontSize: "16px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         width: "30px",
//         height: "30px",
//         borderRadius: "50%",
//         background: "rgba(255,255,255,0.2)",
//         textDecoration: "none",
//         transition: "0.3s",
//       }}
//       onMouseEnter={(e) => (e.target.style.background = "#fff", e.target.style.color = "rgb(0,111,47)")}
//       onMouseLeave={(e) => (e.target.style.background = "rgba(255,255,255,0.2)", e.target.style.color = "#fff")}
//     >
//       <FaInstagram />
//     </a>
//   </div> */}
// </div>


//       {/* 🔻 MAIN HEADER */}
//       <div style={{
//         position: "fixed",
//         top: showTopBar ? "50px" : "0px",
//         width: "100%",
//         background: "#fff",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//         zIndex: 1000,
//         transition: "top 0.3s",
//       }}>
//         <div style={{
//           height: "90px",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "0 30px",
//         }}>
//           {/* LOGO */}
//           {/* <div 
//             onClick={() => handleNavClick('/')} 
//             style={{ fontWeight: "700", fontSize: "20px", fontFamily: 'sans-serif', color: "rgb(0,111,47)", cursor: "pointer" }}
//           >
//             DPS Kids Ladwa
//           </div> */}
// {/* 
// <div 
//   onClick={() => handleNavClick('/')} 
//   style={{ cursor: "pointer" }}
// >
//   <img 
//     src={logo} 
//     alt="DPS Kids Ladwa" 
//     style={{ height: "80px", objectFit: "contain" }}
//   />
// </div> */}

// <div 
//   onClick={() => handleNavClick('/')} 
//   style={{ 
//     cursor: "pointer",
//     // paddingLeft: "-60px", // 🔥 thoda left shift
//     marginLeft:-35
//   }}
// >
//   <img 
//     src={logo} 
//     alt="DPS Kids Ladwa" 
//     style={{ 
//       height: "clamp(50px, 8vw, 80px)", // 🔥 responsive size
//       objectFit: "contain"
//     }}
//   />
// </div>
//           {/* 📱 MOBILE HAMBURGER */}
//           <div className="hamburger" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
//             <div className={`line ${isMobileMenuOpen ? "active" : ""}`}></div>
//             <div className={`line ${isMobileMenuOpen ? "active" : ""}`}></div>
//             <div className={`line ${isMobileMenuOpen ? "active" : ""}`}></div>
//           </div>

//           {/* MENU LINKS */}
//           <div className={`nav-links ${isMobileMenuOpen ? "open" : ""}`}>
//             {/* HOME */}
//             {/* HOME - FIXED */}
//  {/* HOME BUTTON - FIXED */}
// <span 
//   onClick={() => handleNavClick('/')}  // ✅ '/' use karo
//   style={{ 
//     ...navStyle, 
//     color: isCurrentPage('/') ? "rgb(0,111,47)" : "#222",  // ✅ Match karta hai
//     fontWeight: "400"
//   }}
// >
//   HOME
// </span>

//             {/* ABOUT US */}
//             <div onMouseEnter={() => handleEnter("about")} onMouseLeave={handleLeave} className="nav-item-container">
//               <span onClick={() => toggleMobileSubmenu("about")} style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/ourscreen') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/ourscreen') ? "600" : "600"
//               }}>ABOUT US ▼</span>
//               <div className={`dropdown ${openMenu === "about" ? "show" : ""}`}>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/ourscreen')}>Our School</div>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/StaffSection')}>School staff</div>
//                  <div className="dropdown-item" onClick={() => handleNavClick('/fees')}>Fee Structure</div>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/PrincipalMessage')}>Principle Message</div>
//                <div className="dropdown-item" onClick={() => handleNavClick('/directormessage')}>Director Message</div>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/TransportSection')}>School Transport</div>
//               </div>
//             </div>

//             {/* MISSION */}
//             <div onMouseEnter={() => handleEnter("mission")} onMouseLeave={handleLeave} className="nav-item-container">
//               <span onClick={() => toggleMobileSubmenu("mission")} style={{ 
//                 ...navStyle, 
//                 color: isCurrentPage('/MissionVision') ? "rgb(0,111,47)" : "#222",
//                 fontWeight: isCurrentPage('/MissionVision') ? "600" : "600"
//               }}>MISSION & VISION ▼</span>
//               <div className={`dropdown ${openMenu === "mission" ? "show" : ""}`}>
//                 <div className="dropdown-item" onClick={() => handleNavClick('/MissionVision')}>Our Mission</div>
                
//               </div>
//             </div>

//             <span 
//   onClick={() => handleNavClick('/AimsObjectives')} 
//   style={{ ...navStyle, color: isCurrentPage('/AimsObjectives') ? "rgb(0,111,47)" : "#222", fontWeight: "600", fontFamily: 'sans-serif' }}
// >
//   AIMS & OBJECTIVES
// </span>
//             <span 
//   onClick={() => handleNavClick('/SchoolCertificates')} 
//   style={{ ...navStyle, color: isCurrentPage('/SchoolCertificates') ? "rgb(0,111,47)" : "#222", fontWeight: "600", fontFamily: 'sans-serif' }}
// >
//    Mandatory Disclosure
// </span>
// <span 
//   onClick={() => handleNavClick('/facilities')} 
//   style={{ ...navStyle, color: isCurrentPage('/facilities') ? "rgb(0,111,47)" : "#222", fontWeight: "600", fontFamily: 'sans-serif' }}
// >
//   FACILITIES
// </span>

// <span 
//   onClick={() => handleNavClick('/SportsFitness')} 
//   style={{ ...navStyle, color: isCurrentPage('/SportsFitness') ? "rgb(0,111,47)" : "#222", fontWeight: "600", fontFamily: 'sans-serif' }}
// >
//   SPORTS FITNESS
// </span>

// <span 
//   onClick={() => handleNavClick('/Activities')} 
//   style={{ ...navStyle, color: isCurrentPage('/Activities') ? "rgb(0,111,47)" : "#222", fontWeight: "600", fontFamily: 'sans-serif' }}
// >
//   ACTIVITIES
// </span>

// <span 
//   onClick={() => handleNavClick('/ContactUs')} 
//   style={{ ...navStyle, color: isCurrentPage('/ContactUs') ? "rgb(0,111,47)" : "#222", fontWeight: "600", fontFamily: 'sans-serif' }}
// >
//   CONTACT
// </span>
// {/* 
//             <span onClick={() => handleNavClick('/AimsObjectives')} style={{ ...navStyle, color: isCurrentPage('/AimsObjectives') ? "rgb(0,111,47)" : "#222", fontWeight: isCurrentPage('/AimsObjectives') ? "600" : "600" }}>AIMS & OBJECTIVES</span>
//             <span onClick={() => handleNavClick('/facilities')} style={{ ...navStyle, color: isCurrentPage('/facilities') ? "rgb(0,111,47)" : "#222", fontWeight: isCurrentPage('/facilities') ? "600" : "600" }}>FACILITIES</span>
//             <span onClick={() => handleNavClick('/SportsFitness')} style={{ ...navStyle, color: isCurrentPage('/SportsFitness') ? "rgb(0,111,47)" : "#222", fontWeight: isCurrentPage('/SportsFitness') ? "600" : "600" }}>SPORTS FITNESS</span>
//             <span onClick={() => handleNavClick('/Activities')} style={{ ...navStyle, color: isCurrentPage('/Activities') ? "rgb(0,111,47)" : "#222", fontWeight: isCurrentPage('/Activities') ? "600" : "600" }}>ACTIVITIES</span>
//             <span onClick={() => handleNavClick('/ContactUs')} style={{ ...navStyle, color: isCurrentPage('/ContactUs') ? "rgb(0,111,47)" : "#222", fontWeight: isCurrentPage('/ContactUs') ? "600" : "600" }}>CONTACT</span> */}
//           </div>
//         </div>
//       </div>

//       <style>{`
//         .nav-links { display: flex; gap: 20px; }
//         .nav-item-container { position: relative; }
        
//         .dropdown {
//           position: absolute; top: 40px; left: 0; background: #fff;
//           box-shadow: 0 10px 25px rgba(0,0,0,0.1); border-radius: 8px;
//           overflow: hidden; min-width: 200px; z-index: 999;
//           opacity: 0; visibility: hidden; transform: translateY(10px);
//           transition: all 0.25s ease;
//         }
//              .dropdown.show { opacity: 1; visibility: visible; transform: translateY(0px); }
//         .dropdown-item { padding: 12px 16px; cursor: pointer; transition: 0.3s; color: #222; }
//         .dropdown-item:hover { background: rgb(0,111,47); color: #fff !important; }

//         .hamburger { display: none; cursor: pointer; flex-direction: column; gap: 5px; }
//         .line { width: 25px; height: 3px; background: rgb(0,111,47); transition: 0.3s; }

//         @media (max-width: 1150px) {
//           .nav-links { gap: 5px; } /* Thoda gap kam kiya bade laptops ke liye */
//         }

//         @media (max-width: 1024px) {
//           .hide-mobile { display: none; }
//           .hamburger { display: flex; z-index: 1001; }
          
//           .nav-links {
//             position: fixed; top: 0; right: -100%; width: 280px; height: 100vh;
//             background: #fff; flex-direction: column; padding: 100px 20px;
//             transition: 0.4s ease; box-shadow: -5px 0 15px rgba(0,0,0,0.1);
//             overflow-y: auto;
//           }
//           .nav-links.open { right: 0; }
          
//           .dropdown {
//             position: static; opacity: 1; visibility: visible; 
//             box-shadow: none; display: none; transform: none;
//             padding-left: 20px; border-left: 2px solid rgb(0,111,47);
//           }
//           .dropdown.show { display: block; }

//           .line.active:nth-child(1) { transform: translateY(8px) rotate(45deg); }
//           .line.active:nth-child(2) { opacity: 0; }
//           .line.active:nth-child(3) { transform: translateY(-8px) rotate(-45deg); }
//         }
//       `}</style>
//     </>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import logo from "./dpslogo.png";

export default function Header() {
  const [showTopBar, setShowTopBar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [openMenu, setOpenMenu] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [hovered, setHovered] = useState(null);

  const timeoutRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const isCurrentPage = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 60) {
        setShowTopBar(false);
      } else {
        setShowTopBar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // 🔥 UPDATED NAV STYLE
  const navStyle = {
    cursor: "pointer",
    padding: "8px 8px",
    lineHeight: "1.3",
    display: "inline-block",
    fontFamily: "sans-serif",
    transition: "0.3s",
    fontSize: "13px",
    letterSpacing: "0.2px",
  };

  const iconStyle = (name) => ({
    color: hovered === name ? "rgb(0,111,47)" : "#fff",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    background: hovered === name ? "#fff" : "rgba(255,255,255,0.2)",
    textDecoration: "none",
    transition: "all 0.3s ease",
    cursor: "pointer",
  });

  const handleEnter = (menu) => {
    if (window.innerWidth > 1024) {
      clearTimeout(timeoutRef.current);
      setOpenMenu(menu);
    }
  };

  const handleLeave = () => {
    if (window.innerWidth > 1024) {
      timeoutRef.current = setTimeout(() => setOpenMenu(""), 200);
    }
  };

  const toggleMobileSubmenu = (menu) => {
    setOpenMenu(openMenu === menu ? "" : menu);
  };

  const handleNavClick = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
    setOpenMenu("");
  };

  return (
    <>
      {/* TOP BAR */}
      <div
        style={{
          position: "fixed",
          top: showTopBar ? 0 : "-50px",
          width: "100%",
          height: "50px",
          background: "rgb(0,111,47)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          boxSizing: "border-box",
          zIndex: 1100,
          transition: "0.3s",
        }}
      >
        {/* LEFT */}
        <div
          style={{
            fontSize: "14px",
            flexShrink: 0,
            color: "#ffffff",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <span
            style={{
              filter: "brightness(0) invert(1)",
              fontSize: "16px",
            }}
          >
            📞
          </span>

          <span style={{ color: "#ffffff" }}>+91 90534 90023</span>

          <span
            className="hide-mobile"
            style={{
              marginLeft: "10px",
              color: "#ffffff",
            }}
          >
            | ✉️ dpskidsladwa@gmail.com
          </span>
        </div>

        {/* RIGHT ICONS */}
        <div
          style={{
            display: "flex",
            gap: "8px",
            flexShrink: 0,
            paddingLeft: "10px",
          }}
        >
          <a
            href="https://www.facebook.com/dpskidsladwa"
            target="_blank"
            rel="noopener noreferrer"
            style={iconStyle("fb")}
            onMouseEnter={() => setHovered("fb")}
            onMouseLeave={() => setHovered(null)}
          >
            <FaFacebookF />
          </a>

          <a
            href="https://www.instagram.com/dpskids_ladwa"
            target="_blank"
            rel="noopener noreferrer"
            style={iconStyle("ig")}
            onMouseEnter={() => setHovered("ig")}
            onMouseLeave={() => setHovered(null)}
          >
            <FaInstagram />
          </a>
        </div>
      </div>

      {/* MAIN HEADER */}
      <div
        style={{
          position: "fixed",
          top: showTopBar ? "50px" : "0px",
          width: "100%",
          background: "#fff",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          zIndex: 1000,
          transition: "top 0.3s",
        }}
      >
        <div
          style={{
            height: "80px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 20px",
          }}
        >
          {/* LOGO */}
          <div
            onClick={() => handleNavClick("/")}
            style={{
              cursor: "pointer",
              marginLeft: -20,
            }}
          >
            <img
              src={logo}
              alt="DPS Kids Ladwa"
              style={{
                height: "clamp(50px, 7vw, 75px)",
                objectFit: "contain",
              }}
            />
          </div>

          {/* MOBILE HAMBURGER */}
          <div
            className="hamburger"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <div className={`line ${isMobileMenuOpen ? "active" : ""}`}></div>
            <div className={`line ${isMobileMenuOpen ? "active" : ""}`}></div>
            <div className={`line ${isMobileMenuOpen ? "active" : ""}`}></div>
          </div>

          {/* MENU LINKS */}
          <div className={`nav-links ${isMobileMenuOpen ? "open" : ""}`}>
            {/* HOME */}
            <span
              onClick={() => handleNavClick("/")}
              style={{
                ...navStyle,
                color: isCurrentPage("/") ? "rgb(0,111,47)" : "#222",
                fontWeight: "600",
              }}
            >
              HOME
            </span>

            {/* ABOUT */}
            <div
              onMouseEnter={() => handleEnter("about")}
              onMouseLeave={handleLeave}
              className="nav-item-container"
            >
              <span
                onClick={() => toggleMobileSubmenu("about")}
                style={{
                  ...navStyle,
                  color: isCurrentPage("/ourscreen")
                    ? "rgb(0,111,47)"
                    : "#222",
                  fontWeight: "600",
                }}
              >
                ABOUT US ▼
              </span>

              <div
                className={`dropdown ${
                  openMenu === "about" ? "show" : ""
                }`}
              >
                <div
                  className="dropdown-item"
                  onClick={() => handleNavClick("/ourscreen")}
                >
                  Our School
                </div>

                <div
                  className="dropdown-item"
                  onClick={() => handleNavClick("/StaffSection")}
                >
                  School Staff
                </div>

                <div
                  className="dropdown-item"
                  onClick={() => handleNavClick("/fees")}
                >
                  Fee Structure
                </div>

                <div
                  className="dropdown-item"
                  onClick={() => handleNavClick("/PrincipalMessage")}
                >
                  Principal Message
                </div>

                <div
                  className="dropdown-item"
                  onClick={() => handleNavClick("/directormessage")}
                >
                  Director Message
                </div>

                <div
                  className="dropdown-item"
                  onClick={() => handleNavClick("/TransportSection")}
                >
                  School Transport
                </div>
              </div>
            </div>

            {/* MISSION */}
            <div
              onMouseEnter={() => handleEnter("mission")}
              onMouseLeave={handleLeave}
              className="nav-item-container"
            >
              <span
                onClick={() => toggleMobileSubmenu("mission")}
                style={{
                  ...navStyle,
                  color: isCurrentPage("/MissionVision")
                    ? "rgb(0,111,47)"
                    : "#222",
                  fontWeight: "600",
                }}
              >
                MISSION & VISION ▼
              </span>

              <div
                className={`dropdown ${
                  openMenu === "mission" ? "show" : ""
                }`}
              >
                <div
                  className="dropdown-item"
                  onClick={() => handleNavClick("/MissionVision")}
                >
                  Our Mission
                </div>
              </div>
            </div>

            {/* OTHER MENUS */}
            {[
              {
                label: "AIMS & OBJECTIVES",
                path: "/AimsObjectives",
              },
              { 
                label: "MANDATORY DISCLOSURE",
                path: "/SchoolCertificates",
              },
              {
                label: "FACILITIES",
                path: "/facilities",
              },
              {
                label: "SPORTS FITNESS",
                path: "/SportsFitness",
              },
              {
                label: "ACTIVITIES",
                path: "/Activities",
              },
              {
                label: "CONTACT",
                path: "/ContactUs",
              },
            ].map((item, index) => (
              <span
                key={index}
                onClick={() => handleNavClick(item.path)}
                style={{
                  ...navStyle,
                  color: isCurrentPage(item.path)
                    ? "rgb(0,111,47)"
                    : "#222",
                  fontWeight: "600",
                }}
              >
                {item.label}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        .nav-links {
          display: flex;
          gap: 8px;
          align-items: center;
        }

        .nav-item-container {
          position: relative;
        }

        .dropdown {
          position: absolute;
          top: 40px;
          left: 0;
          background: #fff;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border-radius: 8px;
          overflow: hidden;
          min-width: 200px;
          z-index: 999;
          opacity: 0;
          visibility: hidden;
          transform: translateY(10px);
          transition: all 0.25s ease;
        }

        .dropdown.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(0px);
        }

        .dropdown-item {
          padding: 12px 16px;
          cursor: pointer;
          transition: 0.3s;
          color: #222;
          font-size: 14px;
        }

        .dropdown-item:hover {
          background: rgb(0,111,47);
          color: #fff !important;
        }

        .hamburger {
          display: none;
          cursor: pointer;
          flex-direction: column;
          gap: 5px;
        }

        .line {
          width: 25px;
          height: 3px;
          background: rgb(0,111,47);
          transition: 0.3s;
        }

        @media (max-width: 1150px) {
          .nav-links {
            gap: 3px;
          }
        }

        @media (max-width: 1024px) {
          .hide-mobile {
            display: none;
          }

          .hamburger {
            display: flex;
            z-index: 1001;
          }

          .nav-links {
            position: fixed;
            top: 0;
            right: -100%;
            width: 280px;
            height: 100vh;
            background: #fff;
            flex-direction: column;
            padding: 100px 20px;
            transition: 0.4s ease;
            box-shadow: -5px 0 15px rgba(0,0,0,0.1);
            overflow-y: auto;
            align-items: flex-start;
            gap: 10px;
          }

          .nav-links.open {
            right: 0;
          }

          .dropdown {
            position: static;
            opacity: 1;
            visibility: visible;
            box-shadow: none;
            display: none;
            transform: none;
            padding-left: 20px;
            border-left: 2px solid rgb(0,111,47);
          }

          .dropdown.show {
            display: block;
          }

          .line.active:nth-child(1) {
            transform: translateY(8px) rotate(45deg);
          }

          .line.active:nth-child(2) {
            opacity: 0;
          }

          .line.active:nth-child(3) {
            transform: translateY(-8px) rotate(-45deg);
          }
        }
      `}</style>
    </>
  );
}